import { AppEntities } from "../../../../config/entities";
import React from "react";
import { NewCatalogListView } from "../../../Shared/NewCatalogListView";
import { IListViewField } from "../../../Shared/ILIstViewField";
import { CatalogListView } from "../../../Shared/CatalogListView";
import { CatalogListViewToolbar } from "../../../Shared/ListViews/CatalogListViewToolbar";
import { CatalogListViewDefaultToolbarButtons } from "../../../Shared/ListViews/CatalogListViewDefaultToolbarButtons";

const ActivePassiveItemList = () => {
  const fields: IListViewField[] = [];

  return (
    <>
      <CatalogListView fields={fields} entity={AppEntities.ActivePassiveItem}>
        <CatalogListViewToolbar>
          <CatalogListViewDefaultToolbarButtons />
        </CatalogListViewToolbar>
      </CatalogListView>{" "}
    </>
  );
};

export default ActivePassiveItemList;
